// W2Cook Design System — Billing Dashboard
// Mirrors src/theme/tokens.ts in the main Expo app

export const tokens = {
  ember:      "#E8652A",
  sage:       "#7DB87A",
  gold:       "#C9A84C",
  bg:         "#0F0E0C",
  surface:    "#1A1916",
  surfaceAlt: "#242220",
  border:     "#2E2C29",
  borderHover:"#3E3C38",
  text:       "#F2EFE8",
  textMuted:  "#8A8578",
  textDim:    "#5C5A54",
  blue:       "#5B8FD4",
  purple:     "#C47BE0",
  pink:       "#D47BBF",
  teal:       "#5BBDD4",
} as const;

export type TokenKey = keyof typeof tokens;

export const CATEGORY_PALETTE = [
  tokens.ember, tokens.blue, tokens.sage, tokens.purple,
  tokens.gold, tokens.teal, tokens.pink, "#A8D85A", "#D4845B", "#7BB8D4",
];

export const getCategoryColor = (category: string, allCategories: string[]): string => {
  const idx = allCategories.indexOf(category);
  return CATEGORY_PALETTE[idx % CATEGORY_PALETTE.length];
};
